export enum CompareTypes {
    API = 'Api',
    FILES = 'files'
}
